/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import { massDeleteLeads } from "../../../../api/lead";
import CreateLeadCapturePopupCancelIcon from "../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import CloseIcon from "../../../../assets/icons/closeIcon.svg";
import "./lead-qualification-archive-confirmation-popups.scss";

const LeadQualificationArchiveConfirmationPopups= (props: any) => {
   const {
        setIsShowConfirmArchivePopup,
        isShowConfirmArchivePopup,
        setLoading, 
        setAlertMessage, 
        setAlertType,  
        setAlertOpen,
        fetchLeads,
        leadsIds,
        setSelectedLeadsMap,
  } = props;

      const handleConfirmArchive = async () => {
        setLoading(true);
        try {
            const response = await massDeleteLeads({ 'leadsIds': leadsIds });
            setIsShowConfirmArchivePopup(false)
            if (response?.status === 204) {
                setAlertMessage(`Leads Archived Successfully`);
                setAlertType("success");
                setSelectedLeadsMap({})
                fetchLeads();
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setLoading(false);
            setAlertOpen(true);
        }
    };

  return (
    <>
     <Dialog
        open={isShowConfirmArchivePopup}
        // onClose={() => setIsShowConfirmArchivePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`create-lead-capture-popup-cancel`}
      >
        <DialogTitle id="alert-dialog-title">
            <div className="header-wrapper">
              <div className="image-wrapper">
              <div className="title-with-icon">
                <img src={CreateLeadCapturePopupCancelIcon} className="delete-icon"></img>
                <div>{'Archive Duplicates'}</div>
              </div>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={() => setIsShowConfirmArchivePopup(false)}
                />
              </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="cancel-popup-sub-text">
              Are you sure you want to archive the selected leads?
            </div>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() =>setIsShowConfirmArchivePopup(false)} className="cancel-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirmArchive} autoFocus className="action-btn">
            Archive
          </Button>
        </DialogActions>
      </Dialog>          
    </>
  );
}

export default LeadQualificationArchiveConfirmationPopups;
